
export default function ArtistsSection() {
  const artists = [
    {
      name: 'Fanny Barraza',
      specialty: 'Explosión de Diseño y Color',
      experience: '8 años de experiencia',
      workImage: '/images/artists/fanny/w1.png',
      profileImage: '/images/artists/fanny/p.png',
      gradient: 'from-orange-400 via-pink-500 to-purple-600',
      description: 'Especialista en diseños vibrantes y explosivos. Maestra del color que transforma ideas en obras de arte llenas de vida y energía.',
      instagram: 'https://www.instagram.com/fanuxbarraza/',
      instagramHandle: '@fanuxbarraza'
    },
    {
      name: 'Nazareth',
      specialty: 'Black Work y Diseños Oscuros',
      experience: '7 años de experiencia',
      workImage: '/images/artists/naz/w1.png',
      profileImage: '/images/artists/naz/p.png',
      gradient: 'from-gray-800 via-gray-900 to-black',
      description: 'Experta en tatuajes black work, sombreados profundos y diseños con tinta negra. Crea piezas dramáticas y poderosas.',
      instagram: 'https://www.instagram.com/nazareth.ink/',
      instagramHandle: '@nazareth.ink'
    },
    {
      name: 'Paz de Tinta',
      specialty: 'Fine Line y Minimalismo',
      experience: '6 años de experiencia',
      workImage: '/images/artists/paz/w1.png',
      profileImage: '/images/artists/paz/p.png',
      gradient: 'from-rose-300 via-pink-400 to-rose-500',
      description: 'Maestra del fine line y diseños minimalistas. Especializada en líneas delicadas y tatuajes sutiles llenos de elegancia.',
      instagram: 'https://www.instagram.com/paz_de_tinta/',
      instagramHandle: '@paz_de_tinta'
    },
    {
      name: 'Agatha Pintologa',
      specialty: 'Mitología de Chiloé y Botánica',
      experience: '5 años de experiencia',
      workImage: '/images/artists/agatha/w1.png',
      profileImage: '/images/artists/agatha/p.png',
      gradient: 'from-purple-400 via-pink-500 to-red-500',
      description: 'Especialista en rescatar la magia del sur. Sus diseños fusionan la mitología chilota con ilustraciones botánicas únicas.',
      instagram: 'https://www.instagram.com/agatha.pintologa/',
      instagramHandle: '@agatha.pintologa'
    }
  ];

  return (
    <section id="tatuadoras" className="py-20 bg-gradient-to-b from-white to-pink-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nuestras <span className="text-pink-500">Tatuadoras</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conoce a nuestro equipo de <strong>artistas profesionales</strong> dedicadas a crear
            <strong> tatuajes únicos y personalizados</strong> que reflejan tu esencia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {artists.map((artist, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col h-full"
            >
              {/* Work Image / Gallery with "Fake Bokeh" Effect */}
              <div className="relative overflow-hidden h-72 bg-gray-900">
                {/* Layer 1: Blurred Background (fills the container) */}
                <div
                  className="absolute inset-0 bg-cover bg-center blur-lg opacity-60 scale-110"
                  style={{ backgroundImage: `url(${artist.workImage})` }}
                ></div>

                {/* Layer 2: Sharp Foreground with Vignette/Mask */}
                <img
                  src={artist.workImage}
                  alt={`Trabajo de ${artist.name}`}
                  className="relative w-full h-full object-cover z-10 transition-transform duration-700 group-hover:scale-105"
                  style={{
                    maskImage: 'radial-gradient(circle at center, black 40%, transparent 100%)',
                    WebkitMaskImage: 'radial-gradient(circle at center, black 40%, transparent 100%)'
                  }}
                />

                {/* Layer 3: Sharp Center (Optional, to ensure core detail is 100% visible if mask is too aggressive) */}
                {/* actually, strictly masking transparent makes it fade to the blurred background underneath? 
                    No, the masked image fades to transparent, revealing the DIV behind it. 
                    The DIV behind it has the BLURRED image. 
                    So: Sharp Image fades to Transparent -> Reveals Blurred Image. 
                    Result: Fake Depth of Field. */}

                {/* Fallback/Overlay to bridge the gap */}
                <div className="absolute inset-0 z-0 bg-black/10"></div>

                {/* Profile Image Overlay */}
                <div className="absolute bottom-[-24px] right-6 z-20">
                  <div className="w-20 h-20 rounded-full border-4 border-white shadow-lg overflow-hidden bg-gray-200">
                    <img
                      src={artist.profileImage}
                      alt={`Perfil de ${artist.name}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              <div className="p-6 pt-8 flex-grow flex flex-col">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-pink-500 transition-colors">
                    {artist.name}
                  </h3>
                </div>

                <a
                  href={artist.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-500 hover:text-pink-500 transition-colors inline-flex items-center mb-3"
                >
                  <i className="ri-instagram-line mr-1"></i>
                  {artist.instagramHandle}
                </a>

                <p className="text-pink-500 font-semibold text-sm mb-2">{artist.specialty}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">{artist.description}</p>

                <a
                  href={artist.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto w-full text-center py-2.5 rounded-lg border border-pink-200 text-pink-500 font-medium hover:bg-pink-50 transition-colors flex items-center justify-center gap-2 group-hover:border-pink-500 group-hover:bg-pink-500 group-hover:text-white"
                >
                  <i className="ri-instagram-line"></i>
                  <span>Ver Portafolio</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}